import React from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { createStyles } from "antd-style";

const useStyle = createStyles(({ css, token }) => {
  return {
    arrayFieldTable: css`
      .ant-form-item-row {
        .ant-form-item-label {
          label {
            display: block;
            height: auto;
            ::after {
              content: "";
              display: none;
            }
            &.ant-form-item-required:not(
                .ant-form-item-required-mark-optional
              )::before {
              display: none;
            }
            &.ant-form-item-required:not(
                .ant-form-item-required-mark-optional
              ) {
              .label {
                ::before {
                  display: inline-block;
                  margin-inline-end: 4px;
                  color: #ff4d4f;
                  font-size: 14px;
                  font-family: SimSun, sans-serif;
                  line-height: 1;
                  content: "*";
                }
              }
            }
            .label {
              ::after {
                content: ":";
                position: relative;
                margin-block: 0;
                margin-inline-start: 2px;
                margin-inline-end: 8px;
              }
            }

            .label-help-text {
              white-space: break-spaces;
            }
          }
        }
      }
    `,
  };
});

export const InputWrapper = ({
  label,
  labelHelpText,
  error,
  helperText,
  required,
  layout = "horizontal",
  labelCol,
  wrapperCol,
  children,
}) => {
  // Default column settings for horizontal layout
  const defaultLabelCol = layout === "horizontal" ? { span: 8 } : undefined;
  const defaultWrapperCol = layout === "horizontal" ? { span: 16 } : undefined;
  const { styles } = useStyle();

  return (
    <Form.Item
      className={styles.arrayFieldTable}
      label={
        label && (
          <>
            <label className="label">{label}</label>
            {labelHelpText && (
              <div className="label-help-text">
                <small>{labelHelpText}</small>
              </div>
            )}
          </>
        )
      }
      validateStatus={error ? "error" : ""}
      help={helperText}
      required={required}
      style={{
        marginBottom: helperText ? "24px" : "0px",
      }}
      layout={layout}
      labelCol={labelCol || defaultLabelCol}
      wrapperCol={wrapperCol || defaultWrapperCol}
      labelAlign="left"
    >
      {children}
    </Form.Item>
  );
};

InputWrapper.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  children: PropTypes.node.isRequired,
};

export default InputWrapper;
